import { Component, Input, OnInit } from "@angular/core";
import { Reference } from "../reference";
import { SupplierReference } from "../supplier-reference";

@Component({
  selector: 'tr[reference-result]',
  styleUrls: ['./reference-result.component.css'],
  templateUrl: './reference-result.component.html',
})
export class ReferenceResultComponent implements OnInit {
  @Input()
  public reference!: Reference;

  public supplierReference!: SupplierReference;

  ngOnInit(): void {
    for (const supplierReference of this.reference.supplierReferences) {
      if (supplierReference.active) {
        this.supplierReference = supplierReference;
      }
    }
  }

}